import { render, staticRenderFns } from "./ContentLoadingFullWidth.vue?vue&type=template&id=f8c129dc"
import script from "./ContentLoadingFullWidth.vue?vue&type=script&lang=js"
export * from "./ContentLoadingFullWidth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports